export interface UserProfile {
  name: string;
  referralCode: string;
}

export interface StatCardData {
  label: string;
  value: string;
  icon?: string;
  trend?: {
    percentage: number;
    isPositive: boolean;
    text: string;
  };
  chartData?: number[];
}

export interface MemberStats {
  newMembers: number;
  activeMembers: number;
  lockedSuspended: { locked: number; suspended: number };
  revenue: string;
  conversionRate: number;
  referralMembers: number;
}

export interface RegistrationData {
  date: string;
  count: number;
}

export interface UnPaidRegistrationData {
  date: string;
  count: number;
}

export interface OverdueRegistrationData {
  date: string;
  count: number;
}
export interface InvestmentPackage {
  name: string;
  value: number;
  memberCount: number;
  totalValue: number;
}

export interface RecentMember {
  id: string;
  name: string;
  avatar: string;
  joinDate: string;
  investment: string;
}

export interface Commission {
  id: string;
  memberName: string;
  date: string;
  amount: string;
  type: 'direct' | 'indirect';
}

export const mockUserProfile: UserProfile = {
  name: 'Nguyễn Văn An',
  referralCode: 'NVA2024',
};

export const mockStats: StatCardData[] = [
  {
    label: 'Tổng đầu tư',
    value: '0',
    trend: {
      percentage: 0,
      isPositive: true,
      text: 'So với tháng trước',
    },
    chartData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  },
  {
    label: 'Tổng doanh thu',
    value: '0',
    trend: {
      percentage: 0,
      isPositive: true,
      text: 'So với tháng trước',
    },
    chartData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  },
  {
    label: 'Thành viên giới thiệu',
    value: '0',
    trend: {
      percentage: 0,
      isPositive: true,
      text: 'So với tháng trước',
    },
    chartData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  },
  {
    label: 'Gói đầu tư đang hoạt động',
    value: '0',
    trend: {
      percentage: 0,
      isPositive: true,
      text: 'So với tháng trước',
    },
    chartData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  },
];

export const mockMemberStatsByPeriod: Record<string, MemberStats> = {
  today: {
    newMembers: 0,
    activeMembers: 0,
    lockedSuspended: { locked: 0, suspended: 0 },
    revenue: '0',
    conversionRate: 0.0,
    referralMembers: 0,
  },
  week: {
    newMembers: 0,
    activeMembers: 0,
    lockedSuspended: { locked: 0, suspended: 0 },
    revenue: '0',
    conversionRate: 0.0,
    referralMembers: 0,
  },
  month: {
    newMembers: 0,
    activeMembers: 0,
    lockedSuspended: { locked: 0, suspended: 0 },
    revenue: '0',
    conversionRate: 0.0,
    referralMembers: 0,
  },
};

export const mockUnPaidRegistrationDataByDay: UnPaidRegistrationData[] = [
  { date: 'Thứ 2', count: 0 },
  { date: 'Thứ 3', count: 0 },
  { date: 'Thứ 4', count: 0 },
  { date: 'Thứ 5', count: 0 },
  { date: 'Thứ 6', count: 0 },
  { date: 'Thứ 7', count: 0 },
  { date: 'Chủ Nhật', count: 0 },
];

export const mockUnPaidRegistrationDataByWeek: UnPaidRegistrationData[] = [
  { date: 'Tuần 1', count: 0 },
  { date: 'Tuần 2', count: 0 },
  { date: 'Tuần 3', count: 0 },
  { date: 'Tuần 4', count: 0 },
];

export const mockUnPaidRegistrationDataByMonth: UnPaidRegistrationData[] = [
  { date: 'Th1', count: 0 },
  { date: 'Th2', count: 0 },
  { date: 'Th3', count: 0 },
  { date: 'Th4', count: 0 },
  { date: 'Th5', count: 0 },
  { date: 'Th6', count: 0 },
  { date: 'Th7', count: 0 },
  { date: 'Th8', count: 0 },
  { date: 'Th9', count: 0 },
  { date: 'Th10', count: 0 },
  { date: 'Th11', count: 0 },
  { date: 'Th12', count: 0 },
];

export const mockOverdueRegistrationDataByDay: OverdueRegistrationData[] = [
  { date: 'Thứ 2', count: 0 },
  { date: 'Thứ 3', count: 0 },
  { date: 'Thứ 4', count: 0 },
  { date: 'Thứ 5', count: 0 },
  { date: 'Thứ 6', count: 0 },
  { date: 'Thứ 7', count: 0 },
  { date: 'Chủ Nhật', count: 0 },
];

export const mockOverdueRegistrationDataByWeek: OverdueRegistrationData[] = [
  { date: 'Tuần 1', count: 0 },
  { date: 'Tuần 2', count: 0 },
  { date: 'Tuần 3', count: 0 },
  { date: 'Tuần 4', count: 0 },
];

export const mockOverdueRegistrationDataByMonth: OverdueRegistrationData[] = [
  { date: 'Th1', count: 0 },
  { date: 'Th2', count: 0 },
  { date: 'Th3', count: 0 },
  { date: 'Th4', count: 0 },
  { date: 'Th5', count: 0 },
  { date: 'Th6', count: 0 },
  { date: 'Th7', count: 0 },
  { date: 'Th8', count: 0 },
  { date: 'Th9', count: 0 },
  { date: 'Th10', count: 0 },
  { date: 'Th11', count: 0 },
  { date: 'Th12', count: 0 },
];

export const mockRegistrationDataByDay: RegistrationData[] = [
  { date: 'Thứ 2', count: 0 },
  { date: 'Thứ 3', count: 0 },
  { date: 'Thứ 4', count: 0 },
  { date: 'Thứ 5', count: 0 },
  { date: 'Thứ 6', count: 0 },
  { date: 'Thứ 7', count: 0 },
  { date: 'Chủ Nhật', count: 0 },
];

export const mockRegistrationDataByWeek: RegistrationData[] = [
  { date: 'Tuần 1', count: 0 },
  { date: 'Tuần 2', count: 0 },
  { date: 'Tuần 3', count: 0 },
  { date: 'Tuần 4', count: 0 },
];

export const mockRegistrationDataByMonth: RegistrationData[] = [
  { date: 'Th1', count: 0 },
  { date: 'Th2', count: 0 },
  { date: 'Th3', count: 0 },
  { date: 'Th4', count: 0 },
  { date: 'Th5', count: 0 },
  { date: 'Th6', count: 0 },
  { date: 'Th7', count: 0 },
  { date: 'Th8', count: 0 },
  { date: 'Th9', count: 0 },
  { date: 'Th10', count: 0 },
  { date: 'Th11', count: 0 },
  { date: 'Th12', count: 0 },
];

export const mockInvestmentPackages: InvestmentPackage[] = [
  {
    name: 'PIONEER',
    value: 300000000,
    memberCount: 0,
    totalValue: 0,
  },
  {
    name: 'TITAN',
    value: 1500000000,
    memberCount: 0,
    totalValue: 0,
  },
];

export const mockRecentMembers: RecentMember[] = [
];

export const mockRecentCommissions: Commission[] = [
];
